/** Keep in sync with `editor.scss` / Editor.js mobile toolbar breakpoint. */
export const DOCUMENT_EDITOR_MOBILE_MAX_PX = 650;
